import { useNavigate } from 'react-router-dom';

interface UsageLimitModalProps {
  tier: string;
  used: number;
  limit: number;
  periodEnd: string;
  onClose: () => void;
}

export function UsageLimitModal({ tier, used, limit, periodEnd, onClose }: UsageLimitModalProps) {
  const navigate = useNavigate();

  const formattedDate = periodEnd
    ? new Date(periodEnd).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
    : 'your current billing period';

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="card p-8 max-w-md w-full text-center">
        {/* Warning icon */}
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-amber-500/20 flex items-center justify-center">
          <svg className="w-8 h-8 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>

        <h2 className="text-xl font-bold text-white mb-2">Usage Limit Reached</h2>
        <p className="text-surface-400 mb-4">
          You've used {used > 0 ? `all ${limit}` : 'all available'} transforms on the{' '}
          <span className="text-primary-400 font-medium capitalize">{tier}</span> plan
          {periodEnd ? ` until ${formattedDate}` : ''}.
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => {
              onClose();
              navigate('/pricing');
            }}
            className="btn-primary w-full"
          >
            View Pricing Plans
          </button>
          <button
            onClick={onClose}
            className="btn-secondary w-full"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
